import {createReducer} from '../utility'




export const individualApplication = createReducer({},{
    "FETCH_INDIVIDUAL_APPLICATION_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                application: data
            }
        }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_APPLICATIONS"(state, {data}){
        return{
            ...state,
            application: null
        }
    } 
})

export const hasUpdatedIndividualApplication = createReducer({},{
    "INDIVIDUAL_APPLICATION_UPDATED"(state, {data}){
        if(data){
            return {
                ...state,
                message: data
            }
        }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_PAYMENT_LOADER"(state, {data}){
        if(data){
            return {
                ...state,
                message: null
            }
    }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_APPLICATIONS"(state, {data}){
        return{
            ...state,
            message: null
        }
    }  
})

export const individualApplicationReport = createReducer({},{
    "FETCH_INDIVIDUAL_APPLICATION_REPORT_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                application: data
            }
        }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_APPLICATIONS"(state, {data}){
        return{
            ...state,
            application: null
        }
    }
})


export const submittedApplication = createReducer({},{
    "SUBMIT_INDIVIDUAL_APPLICATION_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                response: data
            }
        }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_APPLICATIONS"(state, {data}){
        return{
            ...state,
            response: null
        }
    }
})

export const hasDeletedApplication = createReducer({},{
    "HAS_DELETED_APPLICATION"(state, {data}){
        if(data){
            return {
                ...state,
                deleted: data
            }
        }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_APPLICATIONS"(state, {data}){
        return{
            ...state,
            deleted: null
        }
    }
})

export const validateMembership = createReducer({},{
    "VALIDATED_MEMBERSHIP_NUMBER"(state, {data}){
        if(data){
            return {
                ...state,
                data:data
            }
        }else{
            return{
                ...state
            }
        }
    },
})


export const fetchClassDetails = createReducer({},{
    "CLASS_DETAILS_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                details:data
            }
        }else{
            return{
                ...state
            }
        }
    },
})


export const fetchClassNotesDetails = createReducer({},{
    "CLASS_NOTES_DETAILS_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                notes:data
            }
        }else{
            return{
                ...state
            }
        }
    },
})

export const fetchCountries = createReducer({},{
    "HAS_FETCHED_COUNTRIES"(state, {data}){
        if(data){
            return {
                ...state,
                countries:data.data
            }
        }else{
            return{
                ...state
            }
        }
    },
})